// This is just an example,
// so you can safely delete all default props below

export default {
    text_inactive_header: 'Automatisk utlogging',
    text_inactive_message1: 'Grunnet inaktivitet blir du automatisk logget ut om',
    text_inactive_message2: 'sekunder.',
    text_inactive_message3: 'Ønsker du å forbli innlogget?',
    text_auto_signed_out_title: 'Utlogget pga. inaktivitet',
    text_auto_signed_out_description: 'Du er logget ut pga inaktivitet',
}
